module.exports = __webpack_public_path__ + "static/media/FTDES_Power_BI.50f15315.png";